import React, {useState} from "react";
import { useTranslation } from "next-i18next";
import {
    BetterResourceUtilization,
    CompetitiveAdvantage,
    CustomizeDataRetention,
    EnhancedSecurity, EnhancedSecurityComp,
    EnhanceSecurity,
    FasterIssueResolution,
    FasterIssueResolutionMw,
    FasterIssueResolutionSolution,
    ImproveApplication,
    ImproveCustomer,
    ImprovedUserExperience,
    ImproveSystemReliability,
    IncreasedEfficiency,
    MwSmallIcon,
    OptimizeInfra, OptimizeOnTheGo,
    ReduceDowntimeMTTR,
    Scalable,
    Training,
} from "../../components/v2/icons";
import Accordion from "../../components/v2/accordion/accordion";
import ProductResources from "../../components/v2/product/product-resource";
import Card from "../../components/v2/cards/card";
import CallToActionBlog from "../../components/v2/blog/call-to-action-blog";
import Dialog from "../../components/v2/dialog";
import ProductHeroSection from "../../components/v2/common/product-hero";
import SolutionFeatureSection from "../../components/v2/common/solution-feature";
import ClientTestimonials from "../../components/v2/mw-carousel/testimonial";
import SolutionsHeroSection from "../../components/v2/common/solutions-hero";
import CardWithIcon from "../../components/v2/cards/card-with-icon";
import TrustedCompanyTopHeading from "../../components/v2/mw-carousel/trust-company-heading-top";

export default function TechnologySolution() {
    const { t } = useTranslation("common");
    const i18nData = t('solutions.technology', { returnObjects: true }) as any;
    const resource = Array.isArray(i18nData?.resources) ? i18nData.resources : [];
    const sectionsData = Array.isArray(i18nData?.sections) ? i18nData.sections : [];
    const heroCardDetails = Array.isArray(i18nData?.hero?.cards) ? i18nData.hero.cards : [];
    const introCards = Array.isArray(i18nData?.introCards) ? i18nData.introCards : [];

    // CardWithIcon icon order
    const cardIcons = [
        <ImproveSystemReliability key={0}/>,
        <FasterIssueResolutionMw key={1}/>,
        <BetterResourceUtilization key={2}/>,
        <EnhancedSecurityComp key={3}/>,
        <OptimizeOnTheGo key={4}/>
    ];

    return (
        <>
            <SolutionsHeroSection
                title={<h1><span className='text-gradient'>{String(i18nData?.hero?.titlePrefix ?? '')}</span> {String(i18nData?.hero?.titleSuffix ?? '')}</h1>}
                tag={typeof i18nData?.hero?.tag === 'string' ? i18nData.hero.tag : ''}
                description={<p>{String(i18nData?.hero?.description ?? '')}</p>}
                cardData={heroCardDetails}
            />

            <section className={"mw-card solutions-mw-card"}>
                <div className={"container"}>
                    <div className={"d-flex card-items"}>
                        <div className={"card-item"}>
                            <h2>{String(i18nData?.sectionIntro?.title ?? '')}</h2>
                            <p>{String(i18nData?.sectionIntro?.description ?? '')}</p>
                        </div>
                        {introCards.map((card, idx) => (
                            <CardWithIcon key={idx} icon={cardIcons[idx]}
                                          title={card.title}
                                          description={card.description}/>
                        ))}
                    </div>
                </div>
            </section>

            <TrustedCompanyTopHeading/>

            <CallToActionBlog
                title={t('solutions.common.optimizeInteractionsTitle')}
                isSignupBtn={true}
                isButton={true}
            />

            <section className={"user-monitor solutions_page"} id={'know-more'}>
                <div className={"container"}>
                    <div className={'section-tag testimonial pd-right'}>{t('solutions.technology.section.tag')}</div>
                    <h2 dangerouslySetInnerHTML={{ __html: t('solutions.technology.section.heading') }}></h2>
                    {sectionsData.map((section, index) => (
                        <SolutionFeatureSection
                            key={index}
                            image={section.image}
                            imageAlt={section.imageAlt}
                            title={section.title}
                            list={section.list}
                            category={section.category}
                        />
                    ))}
                </div>
            </section>

            <ClientTestimonials />

            <ProductResources resources={resource}/>
        </>
    )
}